import { Col } from "reactstrap";
import SortableList from "../../Common/Components/Lists/SortableList";
import { CustomButton } from "../../Common/Components/Button/CustomButton";
import { useNavigate } from "react-router-dom";
import { ADMIN_PATHS, ORGANIZATION_PATHS } from "../../config";
import { useTranslation } from "react-i18next";
import ResponseUserModel from "../../User/Models/Response/ResponseUserModel";
import { SaveLocalStorage } from "../../Common/Helpers/SaveLocalStorage";

export function OrgUsersList({ organizationId }) {
    const { t } = useTranslation();
    const navigate = useNavigate();
    //SaveLocalStorage('currentPage', 1);

    const renderActionColumn = (item) => (
        <CustomButton
            icon="bx bx-show pb-1"
            iconColor="#157553"
            hoverIconColor='white'
            hoverButtonColor='#A3C2B8'
            iconSize={4}
            buttonColor="#cde0da"
            tooltipText={t('button.info')}
            customClasses="rounded"
            buttonBorder={false}
            id={item.id}
            onClick={() => navigate(`${ADMIN_PATHS.ADMIN_USER_INFO}?id=${item.id}`, { state: { from: "organization-list", organizationId } })}
        />
    );

    const columns = ["visualId", 'firstName','lastName','email','phone'];
    const ignoreFields = ["Roles", "Id", "Addresses","Pnr"];
    const listOptions = {
        "model": ResponseUserModel,
         'columns':columns,
        "actions": {
            "actionColumn" : renderActionColumn,
        },
        "exportIsAvailable": true,
        "urlGetListItemsToExport": `/org/users/search/filter?organizationId=${organizationId}`,
        "nameFile": t('adminLabel.orgUsers'),
        "ignoreFields" : columns,
        "filterTestIsAvailable": true,
        "urlGetSearch" : `/org/users/search/filter?organizationId=${organizationId}`,
        "viewName": "OrgUsersList",
        "ignoreUrlParams": true,
    };

    return (
        <Col lg="12" className='card card-backend p-4 mb-5'>
            <h2 className="pb-2 rokkitt-font">{t('adminLabel.orgUser')}</h2>
            <SortableList listOptions={listOptions} />
        </Col>
    );
}
